"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var student_orders_controller_1 = __importDefault(require("./student-orders.controller"));
var student_orders_html_1 = __importDefault(require("./student-orders.html"));
function getCanPurchaseNewServices(PoliciesModel) {
    return PoliciesModel.getByID("storefront").then(function (response) {
        var policyMeta = {};
        response.policy.policymeta.forEach(function (meta) {
            policyMeta[meta.meta_key] = meta.meta_value;
        });
        if (!policyMeta.allows_students_to_purchase_new_services_in_app) {
            return true;
        }
        return policyMeta.allows_students_to_purchase_new_services_in_app === "Y";
    });
}
getCanPurchaseNewServices.$inject = ["PoliciesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.orders", {
        url: "/orders",
        controller: student_orders_controller_1.default,
        controllerAs: "vm",
        template: student_orders_html_1.default,
        resolve: {
            canPurchaseNewServices: getCanPurchaseNewServices,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.student,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.orders", [])
    .config(config)
    .controller("StudentOrdersController", student_orders_controller_1.default);
